import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone } from "lucide-react";

const FinalCTASection = () => {
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      {/* Background Accent */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-primary rounded-full blur-3xl" />
      </div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
            Ready to Get Started?
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
            Elevate Your Listings Today
          </h2>
          <p className="text-muted-foreground text-lg mb-10">
            Join hundreds of successful agents who trust Luminate Media to showcase 
            their properties. Let's create something exceptional together.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="hero" size="xl" asChild>
              <Link to="/book">
                Book Now
                <ArrowRight className="ml-2" size={18} />
              </Link>
            </Button>
            <Button variant="heroOutline" size="xl" asChild>
              <Link to="/contact">
                <Phone className="mr-2" size={18} />
                Contact Us
              </Link>
            </Button>
          </div>
          
          <p className="mt-8 text-sm text-muted-foreground">
            Most projects delivered in 24-48 hours • Serving Washington & Arkansas
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTASection;
